"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawCashUploadConfigSchema = exports.CashUploadOptionSchema = exports.RawUploadConfigSchema = exports.SupplementalTapePropertiesSchema = exports.RepaymentTapePropertiesSchema = exports.CashBalanceFeedPropertiesSchema = exports.LoanTapePropertiesSchema = exports.LenderVerificationConfigSchema = exports.borrowerEligibilityResultsArtifactSlugSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.borrowerEligibilityResultsArtifactSlugSchema = v4_1.z
    .record(v4_1.z.string(), v4_1.z.string())
    .describe('Slugs pointing to the borrower eligibility results artifact for each loan product.');
exports.LenderVerificationConfigSchema = v4_1.z.object({
    description: v4_1.z.string(),
    receivableResponseTapeArtifactSlug: v4_1.z
        .string()
        .describe('Slug pointing to the receivable response tape artifact.'),
    borrowingBaseReportArtifactSlug: v4_1.z
        .string()
        .describe('Slug pointing to the borrowing base report artifact.'),
    borrowerNumbersArtifactSlug: v4_1.z
        .string()
        .describe('Slug pointing to the artifact that has borrower numbers extracted.'),
    borrowerEligibilityResultsArtifactSlugs: exports.borrowerEligibilityResultsArtifactSlugSchema,
});
// loan tapes must have loanProductSlug and optionally creditFacilitySlug
exports.LoanTapePropertiesSchema = v4_1.z.object({
    creditFacilitySlug: v4_1.z.string().nullable(),
    loanProductSlug: v4_1.z.string(),
});
// cash balance feed must have creditFacilitySlug
exports.CashBalanceFeedPropertiesSchema = v4_1.z.object({
    creditFacilitySlug: v4_1.z.string(),
});
// repayment tapes are not associated with creditFacilitySlug
exports.RepaymentTapePropertiesSchema = v4_1.z.object({
    loanProductSlug: v4_1.z.string(),
});
// supplemental tapes are not associated with creditFacilitySlug or loanProductSlug
exports.SupplementalTapePropertiesSchema = v4_1.z.object({});
/**
 * Configuration for uploading a file to the borrowing base pipeline.
 * This will be used by BBPL monitor.
 */
exports.RawUploadConfigSchema = v4_1.z.object({
    fileExtension: finley_types_1.Util.SupportedFileExtensionSchema.nullable().describe('Type of file supported for upload. For cashBalanceFeedContext this will be null.'),
    baseFilename: v4_1.z
        .string()
        .describe('BaseFile name (example: orgSlug/cfslug/flexloantape) to be used for uploading the file.'),
    externalDisplayName: v4_1.z
        .string()
        .describe('Surfaced on UI by Data Pipeline like "Flex Loan Tape | Fx Supplemental Tape | Cash Balance Feed | etc."'),
    meshName: v4_1.z
        .string()
        .optional()
        .describe('Optional mesh name for the mesh that this file belongs to.'),
});
exports.CashUploadOptionSchema = v4_1.z.enum(['tape', 'fetch', 'form']);
exports.RawCashUploadConfigSchema = exports.RawUploadConfigSchema.extend({
    cashUploadOptions: v4_1.z
        .array(exports.CashUploadOptionSchema)
        .optional()
        .describe('Options to upload cash balances.'),
});
//# sourceMappingURL=tape-builder-base.js.map